import { render, staticRenderFns } from "./PieChartV2.vue?vue&type=template&id=1a886cd4&"
import script from "./PieChartV2.vue?vue&type=script&lang=js&"
export * from "./PieChartV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports